import React from 'react';

interface SkeletonCardProps {
  height?: number;
  w?: number | string;
  style?: React.CSSProperties;
  className?: string;
}

export default function SkeletonCard({ height = 80, w, style, className = '' }: SkeletonCardProps) {
  return (
    <div
      className={className}
      style={{
        height,
        width: w,
        background: '#1e1e1e',
        borderRadius: 10,
        animation: 'skeleton-pulse 1.5s ease-in-out infinite',
        ...style,
      }}
    />
  );
}
